module.exports = {"en":{"translation":{"test":"A test of i18next","sec1":"Sec1","default":"Default","detail":"Detail","sec2":"Sec2","thing":"thing","thing_plural":"thingies"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/index.js
// module id = 989
// module chunks = 1